import React from 'react';

export default function CategoriesMaintenance() {
  return <div>CategoriesMaintenance</div>;
}
